import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHome = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.0295 2.58988C11.5893 2.1149 12.4107 2.1149 12.9705 2.58988L20.4705 8.95352C20.8064 9.23852 21 9.65676 21 10.0973V19.5C21 20.3285 20.3284 21 19.5 21H13.75C13.3358 21 13 20.6643 13 20.25V14H11V20.25C11 20.6643 10.6642 21 10.25 21H4.5C3.67157 21 3 20.3285 3 19.5V10.0973C3 9.65676 3.19364 9.23852 3.52953 8.95352L11.0295 2.58988ZM12 3.73364L4.5 10.0973L4.5 19.5H9.5V13.25C9.5 12.8358 9.83579 12.5 10.25 12.5H13.75C14.1642 12.5 14.5 12.8358 14.5 13.25V19.5H19.5V10.0973L12 3.73364Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgHome;
